import Slides from './Slides.js';

import img1 from './images/portfolio/portraits/011.jpg';
import img2 from './images/portfolio/portraits/0216.jpg';
import img3 from './images/portfolio/portraits/041.jpg';
import img4 from './images/portfolio/portraits/DSC_0026.jpg';
import img5 from './images/portfolio/portraits/Dr._A_Granger_IMG_003.jpg';
import img6 from './images/portfolio/portraits/Dr._D_Whalen.jpg';
import img7 from './images/portfolio/portraits/Fiished_IMG_012_45.jpg';
import img8 from './images/portfolio/portraits/Finished.jpg';
import img9 from './images/portfolio/portraits/Grey_finished.jpg';
import img10 from './images/portfolio/portraits/IMG_012.jpg';
import img11 from './images/portfolio/portraits/IMG_013_finished.jpg';
import img12 from './images/portfolio/portraits/IMG_017.jpg';
import img13 from './images/portfolio/portraits/IMG_021.jpg';
import img14 from './images/portfolio/portraits/IMG_022.jpg';
import img15 from './images/portfolio/portraits/IMG_034bw.jpg';
import img16 from './images/portfolio/portraits/IMG_037_finished.jpg';
import img17 from './images/portfolio/portraits/IMG_084_r.jpg';
import img18 from './images/portfolio/portraits/IMG_085_fin.jpg';
import img19 from './images/portfolio/portraits/IMG_116.jpg';
import img20 from './images/portfolio/portraits/IMG_165.jpg';
import img21 from './images/portfolio/portraits/IMG_174.jpg';
import img22 from './images/portfolio/portraits/Img0018.jpg';
import img23 from './images/portfolio/portraits/Img125.jpg';
import img24 from './images/portfolio/portraits/Img401.jpg';
import img25 from './images/portfolio/portraits/J.jpg';
import img26 from './images/portfolio/portraits/John_DeLollis.jpg';
import img27 from './images/portfolio/portraits/K_Deegan_262.jpg';
import img28 from './images/portfolio/portraits/Msg_Kopinski_Img0030.jpg';
import img29 from './images/portfolio/portraits/Rob-Pascucci-lo-res.jpg';
import img30 from './images/portfolio/portraits/Roger_Compton_bw.jpg';
import img31 from './images/portfolio/portraits/Sr._Theresa_img_041.jpg';
import img32 from './images/portfolio/portraits/Trippimg_094.jpg';
import img33 from './images/portfolio/portraits/William_Johnson_IMG3836.jpg';
import img34 from './images/portfolio/portraits/DSC0299_grey.jpg';
import img35 from './images/portfolio/portraits/IMG0284.jpg';
import img36 from './images/portfolio/portraits/IMG0558.jpg';
import img37 from './images/portfolio/portraits/IMG0710.jpg';
import img38 from './images/portfolio/portraits/IMG3725.jpg';
import img39 from './images/portfolio/portraits/IMG4133.jpg';
import img40 from './images/portfolio/portraits/IMG4202.jpg';
import img41 from './images/portfolio/portraits/IMG4511.jpg';
import img42 from './images/portfolio/portraits/IMG5009.jpg';
import img43 from './images/portfolio/portraits/IMG5564.jpg';
import img44 from './images/portfolio/portraits/IMG6029.jpg';
import img45 from './images/portfolio/portraits/IMG7544.jpg';
import img46 from './images/portfolio/portraits/IMG7807.jpg';
import img47 from './images/portfolio/portraits/IMG8615.jpg';
import img48 from './images/portfolio/portraits/IMG8736.jpg';
import img49 from './images/portfolio/portraits/IMG8786.jpg';
import img50 from './images/portfolio/portraits/IMG9373.jpg';
import img51 from './images/portfolio/portraits/IMG9637r.jpg';
import img52 from './images/portfolio/portraits/IMG9732.jpg';
import img53 from './images/portfolio/portraits/img_036.jpg';
import img54 from './images/portfolio/portraits/img_120.jpg';
import img55 from './images/portfolio/portraits/img_134.jpg';

const images = [ 
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
    img14,
    img15,
    img16,
    img17,
    img18,
    img19,
    img20,
    img21,
    img22,
    img23,
    img24,
    img25,
    img26,
    img27,
    img28,
    img29,
    img30,
    img31,
    img32,
    img33,
    img34,
    img35,
    img36,
    img37,
    img38,
    img39,
    img40,
    img41,
    img42,
    img43,
    img44,
    img45,
    img46,
    img47,
    img48,
    img49,
    img50,
    img51,
    img52,
    img53,
    img54,
    img55,
];

function Portraits() {
    return <Slides images={images}/>;
}

export default Portraits;
